import React from "react";
import { cls } from "@wss/cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";

interface SaleBadgeAndPricingProps {
  price: number;
  displayPriceLabel?: boolean;
  priceLabel?: string;
  dataTestId?: string;
  salePricingClassNames?: string;
  saleBadgeExtraClassNames?: string;
  salePrice?: number;
  unitOfMeasure?: string;
  enableSalePriceScreenReaderText?: boolean;
  hideRegularPrice?: boolean;
  hideRegularLabel?: boolean;
  labelClassnames?: string;
}

const SaleBadgeAndPricing = ({
  price,
  displayPriceLabel = false,
  priceLabel = "",
  dataTestId = "",
  salePricingClassNames = "",
  saleBadgeExtraClassNames = "",
  salePrice = 0,
  unitOfMeasure = "",
  enableSalePriceScreenReaderText = false,
  hideRegularPrice = false,
  hideRegularLabel = false,
  labelClassnames = "",
}: SaleBadgeAndPricingProps) => {
  return (
    <p data-testid={dataTestId} className={cls(salePricingClassNames)}>
      <span
        className={cls(
          "text-black",
          "font-bold",
          "bg-yellow-400",
          "rounded-sm",
          "antialiased",
          saleBadgeExtraClassNames,
        )}
      >
        Sale
      </span>
      {hideRegularPrice ? null : (
        <span className={cls(labelClassnames)}>
          {hideRegularLabel ? null : (
            <>
              <span className={cls("sr-only")}>regular price</span>
              <span aria-hidden="true">reg&nbsp;</span>
            </>
          )}
          {displayPriceLabel
            ? priceLabel
            : formatAsCurrency.formatIfUndefined(price)}
          {enableSalePriceScreenReaderText ? (
            <span className={cls("sr-only")}>
              now {formatAsCurrency.formatIfUndefined(salePrice)} /{" "}
              {unitOfMeasure}
            </span>
          ) : null}
        </span>
      )}
    </p>
  );
};

export default SaleBadgeAndPricing;
